import React,{ useEffect, useState } from 'react';
import {LoadMore,Toast,Page,SearchBar } from 'react-weui';
import { getStoreList } from '@/services/home';
import styles from './styles.scss';
import Empty from '@/components/empty';
import SearchInput from '@/components/SearchInput';
import { history } from 'umi';


export default (props) => {

  const [dataList,setDataList] = useState([]);
  const [searchKey,setSearchKey] = useState('');
  const [city,setCity] = useState({areaName:'南京',areaCode:"320100",parentCode: "320000"});


  useEffect(() => {
    let str = window.localStorage.getItem('select_city');
    if (str) {
      setCity(JSON.parse(str));
    }

    getStore();
  },[searchKey]);


  function getStore() {
    let params = {
      pageNo:1,
      pageSize:1000,
    };
    if (searchKey) {
      params.name = searchKey;
    }

    params.cityCode = city.areaCode;
    params.provinceCode = city.parentCode;

    getStoreList(params).then(res => {
      console.log(res);
      if (res && res.code == 200) {
        setDataList(res.data.list);
      }
    });
  }



  return(
    <Page transition={true} infiniteLoader={false} ptr={false}>

      <div className={styles.top_bar}>
        <div className={styles.cityBox} onClick={() =>{
          history.push({pathname:'/home/store/selectProvince',state:{}})

        }}>
          <label>{city.areaName}</label>
          <img src={require('@/assets/down_arrow.png')}/>
        </div>

        <div className={styles.searchBar}>
          <SearchInput placeholder={'请输入关键字'} onChange={(e)=> {
            setSearchKey(e);
          }}/>
        </div>

      </div>


      {dataList.length ? dataList.map(item => (
        <div className={styles.item_box} key={item.id}>
          <img src={item.image}/>
          <div className={styles.item_content}>
            <label className={styles.item_name}>{item.name}</label>
            <label className={styles.item_address}>{item.address}</label>
          </div>
        </div>
      ))
      :
      <Empty text={'暂无门店'}/>}

    </Page>
  )

}
